import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/* eslint-disable no-nested-ternary */
import "./scss/index.scss";
import { Loader } from "@components/atoms";
import { useUserDetails } from "@sdk/react";
import classNames from "classnames";
import envelopeImage from "images/envelope.svg";
import heartImage from "images/heart_red.svg";
import shareImage from "images/share.svg";
import arrowImage from "images/subcategories.svg";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Button } from "../..";
import { AddToWishlist } from "../../ProductDetails/AddToWishlist";
import { ShareState } from "./ShareProject";
export function SaveSelect(_ref) {
  var productId = _ref.productId,
      selectOption = _ref.selectOption,
      selectedProductAttributes = _ref.selectedProductAttributes,
      variantId = _ref.variantId,
      addedToWishlist = _ref.addedToWishlist;
  var intl = useIntl();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var addOrRemoveToWishlistHandler = useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(onClick) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick();

            case 2:
              selectOption(ShareState.addToWishlist);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [selectOption]);
  return React.createElement("div", {
    className: "save-select"
  }, React.createElement(Button, {
    className: "save-select__btn",
    onClick: function onClick() {
      return selectOption(ShareState.save);
    }
  }, React.createElement("div", {
    className: "save-select__btn-icon"
  }, React.createElement("img", {
    src: envelopeImage,
    alt: ""
  })), React.createElement("div", {
    className: "save-select__btn-text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Send to email",
    "id": "components.OverlayManager.ShareProject.SaveSelect.2273147110"
  }, "id", "components.OverlayManager.ShareProject.SaveSelect.2273147110"))), React.createElement("div", {
    className: "save-select__btn-icon"
  }, React.createElement("img", {
    className: "arrow",
    src: arrowImage,
    alt: "arrow-icon"
  }))), React.createElement(Button, {
    className: "save-select__btn",
    onClick: function onClick() {
      return selectOption(ShareState.share);
    }
  }, React.createElement("div", {
    className: "save-select__btn-icon"
  }, React.createElement("img", {
    src: shareImage,
    alt: ""
  })), React.createElement("div", {
    className: "save-select__btn-text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Share to social networks",
    "id": "components.OverlayManager.ShareProject.SaveSelect.3855947154"
  }, "id", "components.OverlayManager.ShareProject.SaveSelect.3855947154"))), React.createElement("div", {
    className: "save-select__btn-icon"
  }, React.createElement("img", {
    className: "arrow",
    src: arrowImage,
    alt: "arrow-icon"
  }))), user && React.createElement(AddToWishlist, {
    productId: productId,
    variantId: variantId,
    selectedProductAttributes: selectedProductAttributes
  }, function (_ref3) {
    var _onClick = _ref3.onClick,
        loading = _ref3.loading;
    return React.createElement(Button, {
      className: classNames("save-select__btn", {
        "save-select__btn--loading": loading
      }),
      onClick: function onClick() {
        addOrRemoveToWishlistHandler(_onClick);
      },
      disabled: loading
    }, React.createElement("div", {
      className: "save-select__btn-icon"
    }, React.createElement("img", {
      src: heartImage,
      alt: ""
    })), React.createElement("div", {
      className: "save-select__btn-text"
    }, addedToWishlist ? React.createElement("span", null, intl.formatMessage(_defineProperty({
      defaultMessage: "Remove from wishlist",
      "id": "components.OverlayManager.ShareProject.SaveSelect.999870927"
    }, "id", "components.OverlayManager.ShareProject.SaveSelect.999870927"))) : React.createElement("span", null, intl.formatMessage(_defineProperty({
      defaultMessage: "Save to wishlist",
      "id": "components.OverlayManager.ShareProject.SaveSelect.1475977489"
    }, "id", "components.OverlayManager.ShareProject.SaveSelect.1475977489")))), React.createElement("div", {
      className: "save-select__btn-icon"
    }, React.createElement("img", {
      className: "arrow",
      src: arrowImage,
      alt: "arrow-icon"
    })), React.createElement("div", {
      className: classNames("save-select__btn-loader", {
        "save-select__btn-loader--active": loading
      })
    }, React.createElement(Loader, null)));
  }));
}